import React, { Component } from 'react';
import { Mid } from '@mid/sdk'
import config from "../../src/config";
import App from '../App';
import axios from 'axios';

class Home extends Component {

    render() {
        const midConfig = ({
            path,
            fm,
            flow,
        }) => ({
            redirectUrl: config.redirectBaseUrl,
            logoutRedirectUrl: config.redirectBaseUrl + "/logout",
            loginInfo: {
                appId: config.clientId,
                oidcConfigUrl: config.oidcConfigUrl,
                authDriver: "mid",
                fm,
                flow,
            },
            landingFn: async () => {
                window.location.hash = "";
            },
        });
        
        const mid = new Mid(midConfig({
            path: config.paths.oidcAuthCodePKCE,
            flow: "auth_code",
        }))

        function parseJwt (token) {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        
            return JSON.parse(jsonPayload);
        }

        axios.defaults.headers.common['Authorization'] = `Bearer ${mid.accessToken()}`
        return (
            <App names={{
                name : parseJwt(mid.accessToken()).name,
                firstName : parseJwt(mid.accessToken()).given_name,
                lastName : parseJwt(mid.accessToken()).family_name
            }} />
        )
    }
}

export default Home;